export default {"src":"/_next/static/media/dummy-user.8a724d6a.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};